import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RestrictionSet } from '@/components/partials/Restrictions/RestrictionSet';

export const useRestrictionsTab = (restrictions: RestrictionSet) => {
  const [error] = useState(false);
  const [displayTerritoryRestrictions, setDisplayTerritoryRestrictions] =
    useState<string>();
  const [territoryCount, setTerritoryCount] = useState<string>();
  const { t } = useTranslation();

  useEffect(() => {
    const formatTerritoryCount = (): string => {
      const restrictionVerb = restrictions.isAllowOnly
        ? t('product.restrictions.allowed')
        : t('product.restrictions.denied');
      return ` (${restrictions.getSelected()?.length ?? 0} ${restrictionVerb})`;
    };

    const displayGroupRestrictionCount = (
      group: string,
      restrictionSet: RestrictionSet
    ): string => {
      const num = restrictionSet.selectedCount(group);
      if (!num) return '';

      return `${num} / ${restrictionSet.totalCount(group)} ${
        restrictionSet.isAllowOnly
          ? t('product.restrictions.allowed')
          : t('product.restrictions.denied')
      }`;
    };

    const formatTerritories = () => {
      const selectedTerritories = restrictions.getSelected();
      if (selectedTerritories.length === 0 && restrictions.isDenyOnly) {
        return t('product.restrictions.clearedForWorldwide');
      } else if (selectedTerritories.length === 0 && restrictions.isAllowOnly) {
        return t('product.restrictions.noTerritoriesAreAllowed');
      }

      return restrictions.groups
        .filter((group) => restrictions.selectedCount(group))
        .map(
          (group) =>
            `${t('territory.region.' + group.toString())} (${displayGroupRestrictionCount(group, restrictions)})`
        )
        .join(', ');
    };

    setDisplayTerritoryRestrictions(formatTerritories());
    setTerritoryCount(formatTerritoryCount());
  }, [restrictions, t]);

  return {
    error,
    displayTerritoryRestrictions,
    territoryCount,
  };
};
